export const DAILY_BUDGET_LESS_THEN_MINIMUM = 'daily_budget-less-then-minimum';
